import { render, staticRenderFns } from "./DutiesList.vue?vue&type=template&id=e5e17fd0&scoped=true&"
import script from "./DutiesList.vue?vue&type=script&lang=js&"
export * from "./DutiesList.vue?vue&type=script&lang=js&"
import style0 from "./DutiesList.vue?vue&type=style&index=0&id=e5e17fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e17fd0",
  null
  
)

export default component.exports